import { render, staticRenderFns } from "./StatChip.vue?vue&type=template&id=5767819c&"
import script from "./StatChip.vue?vue&type=script&lang=js&"
export * from "./StatChip.vue?vue&type=script&lang=js&"
import style0 from "./StatChip.vue?vue&type=style&index=0&id=5767819c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports